module.exports = __webpack_public_path__ + "img/shzp.09a9235a.png";